import { Tooltip } from '@mui/material'
import React from 'react'

const StyledTooltip = ({children, title, placement = "top" }) => {
  return (
    <Tooltip 
        title={title} 
        placement={placement}
        PopperProps={{
            sx: {
                [`& .MuiTooltip-tooltip`]: {    
                backgroundColor : "#2c2626",
                color : "#f5f5f5",
                fontSize : "0.75rem",
                padding : 1,
                borderRadius : 2,
                border : "1px solid #4f3030",
                }
            }
        }}
  >
    {children}
  </Tooltip>
  )
}

export default StyledTooltip